module.exports = __webpack_public_path__ + "img/lightning.07b4b5ce.png";